export const setUserIdForMatomo = (userDetails) => {
  try {
    window._paq?.push(['setUserId', userDetails.sub || userDetails.user_id]);
  } catch (ex) {
    console.log(ex);
  }
};
